/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Email/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromValidate from 'Data/validate.js'
import React from 'react'
import TysiaInput from 'DesignSystem/TysiaInput/index'
import TysiaInputContent from 'DesignSystem/TysiaInput/TysiaInputContent/index'
import TysiaInputField from 'DesignSystem/TysiaInput/TysiaInputField/index'
import TysiaInputLabel from 'DesignSystem/TysiaInput/TysiaInputLabel/index'



/** @type {import('Simple/types.js').View} */
export default function Email({
  children,
  viewPath = "/App/Auth/SignIn/Email",
  isInvalid,
  onChange,
  onSubmit
  
}) {
let signinEmailValueData = fromData.useDataValue({ viewPath,
context: 'signin',
path: 'email',
})
let signinEmailIsValidData = fromData.useDataIsValid({ viewPath,
context: 'signin',
path: 'email',
validate: fromValidate.email,
required: true,
})
let signinEmailChangeData = fromData.useDataChange({ viewPath,
context: 'signin',
path: 'email',
})
let signinEmailSubmitData = fromData.useDataSubmit({ viewPath,
context: 'signin',
})
  return (<React.Fragment
>
<TysiaInput
  viewPath={`${viewPath}/TysiaInput`}
 data="signin.email"
 validate="/Data/validate.js email"
 required={true}
 invalid={!signinEmailIsValidData}
 value={signinEmailValueData}
 onChange={signinEmailChangeData}
 onSubmit={signinEmailSubmitData}
>
{childProps => (
<React.Fragment>
<TysiaInputLabel
{...childProps}
  viewPath={`${viewPath}/TysiaInputLabel`}
 text="Email"
/>
<TysiaInputContent
{...childProps}
  viewPath={`${viewPath}/TysiaInputContent`}
>
{childProps => (
<TysiaInputField
{...childProps}
  viewPath={`${viewPath}/TysiaInputField`}
 type="email"
 autoFocus={true}
 placeholder="you@email.com"
/>
)}
</TysiaInputContent>
</React.Fragment>
)}
</TysiaInput>
{children}
</React.Fragment>)
}